import { ButtonBase } from "@mui/material";
import { useStyles } from "../../../pages/NewOrder/styles";

export default function GroupItem({ group, onClick, active }) {
    const { name, cover } = group;

    const handleClick = () => {
        // Call the provided onClick function when the component is clicked
        if (onClick) {
            onClick(group);
        }
    };

    return (
        <ButtonBase>
            <div
                key={`Category_${group.name}`}
                className={"Category"}
                onClick={handleClick}
            >
                <div
                    key={`Category1_${group.name}`}
                    className={"Category__Name"}
                >
                    {/* {name} */}
                </div>
                <div
                    key={`Category2_${group.name}`}
                    className={"Category__Img"}
                    style={{
                        backgroundImage: `url(${cover})`,
                        border: active ? "3px solid #e14954" : "none",
                    }}
                ></div>
            </div>
        </ButtonBase>
    );
}
